var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M15.51 5.33907H17.39V2.15907C16.4798 2.06442 15.5652 2.01769 14.65 2.01907C11.93 2.01907 10.07 3.67907 10.07 6.71907V9.33907H7V12.8991H10.07V22.0191H13.75V12.8991H16.81L17.27 9.33907H13.75V7.06907C13.75 6.01907 14.03 5.33907 15.51 5.33907Z","fill":"#BABABA"}));
}

Facebook.defaultProps = {"width":"25","height":"25","viewBox":"0 0 25 25","fill":"none"};

module.exports = Facebook;

Facebook.default = Facebook;
